import { render } from "./basictable.vue?vue&type=template&id=5756e434"
import script from "./basictable.vue?vue&type=script&lang=js"
export * from "./basictable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__